import { type IFrontPageActionsContainerProps } from '@framework/theme/front/container/FrontPageActionsContainer.tsx';
import { createPortalSubject } from '@framework/ui/hooks/portal/usePortalSubject.ts';
import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const FRONT_PAGE_ACTIONS_PORTAL = 'front-page-actions--portal';

const portalSubject = createPortalSubject();

/**
 * Permette di posizionare il titolo.
 */
export function FrontPageActionsContainer(
  props: IFrontPageActionsContainerProps,
) {
  const el = useRef(document.createElement('div'));

  const rerenderCount = portalSubject.useRerenderCount();

  // biome-ignore lint/correctness/useExhaustiveDependencies: Force re-render
  useEffect(() => {
    const portal = document.getElementById(FRONT_PAGE_ACTIONS_PORTAL);
    if (!portal) {
      console.warn(
        `L'elemento con id "${FRONT_PAGE_ACTIONS_PORTAL}" non è stato trovato nel documento.  Assicurati che sia presente nel DOM prima di utilizzare il portale.`,
      );
      return;
    }

    portal.appendChild(el.current);

    return () => {
      portal.removeChild(el.current);
    };
  }, [rerenderCount]);

  return ReactDOM.createPortal(props.children, el.current);
}

export const FrontPageActionsPortal = () => {
  portalSubject.useTrigger();

  return <div id={FRONT_PAGE_ACTIONS_PORTAL} />;
};
